export default __webpack_public_path__ + "static/media/ED_sign_in_image-new.6dfb8c5f.jpg";